export const cognitoClientId = process.env.REACT_APP_COGNITO_CLIENT;
export const cognitoPoolId = process.env.REACT_APP_COGNITO_POOL;    
export const region = process.env.REACT_APP_REGION || "";
export const custId = process.env.REACT_APP_CV_CUST_ID;
export const masterId = process.env.REACT_APP_CV_MASTER_ID;
export const masterPassword = process.env.REACT_APP_CV_MASTER_PWD
export const pullAPI = process.env.REACT_APP_PULL_API;
export const proxyAPI = process.env.REACT_APP_PROXY_URL;
export const clientVitalsAPI = process.env.REACT_APP_CLIENTVITALS_API;
export const stripeKey = process.env.REACT_APP_STRIPE_ACCESS_KEY;
export const infoID = process.env.REACT_APP_INFORMATIV_ID;
export const infoPassword = process.env.REACT_APP_INFORMATIV_PASSWORD;
